import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, Checkbox, FormControlLabel } from '@mui/material';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { Prompt } from 'react-router-dom';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import { lookupFilterType } from './contants';

const ReportFilterComponent = ({ reportFilter, index, onPropertyChanged, dictionaryEditorTypes, validation }) => {
  const [t] = useTranslation();
  const showMultipleSelectionBox =
    dictionaryEditorTypes.find(item => item.dictionaryItemId === reportFilter.filterTypeId)?.dictionaryItemCode === lookupFilterType ??
    false;
  return (
    <>
      <Prompt when={reportFilter.changed} message={t('Reports.ReportFilters.LeavingWithoutSavingReportFilter', { index: index + 1 })} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <TextField
            isNumeric
            fullWidth
            decimalScale={0}
            value={reportFilter.orderNo}
            onChange={event => onPropertyChanged('orderNo', event, index)}
            label={t('Reports.ReportFilters.OrderNo')}
            error={!isValid(validation[index].orderNo)}
            helperText={getErrors(validation[index].orderNo)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label={t('Reports.ReportFilters.FilterCode')}
            value={reportFilter.filterCode || ''}
            onChange={event => onPropertyChanged('filterCode', event, index)}
            error={!isValid(validation[index].filterCode)}
            helperText={getErrors(validation[index].filterCode)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label={t('Reports.ReportFilters.Caption')}
            value={reportFilter.filterCaption || ''}
            onChange={event => onPropertyChanged('filterCaption', event, index)}
            error={!isValid(validation[index].filterCaption)}
            helperText={getErrors(validation[index].filterCaption)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Autocomplete
            fullWidth
            label={t('Reports.ReportFilters.EditorType')}
            value={reportFilter.filterTypeId}
            options={dictionaryEditorTypes}
            valueKey='dictionaryItemId'
            labelKey='dictionaryItemCode'
            onChange={event => {
              onPropertyChanged('filterTypeId', event, index);
              onPropertyChanged('allowMultipleSelection', null, index);
            }}
            simpleValue
            error={!isValid(validation[index].filterTypeId)}
            helperText={getErrors(validation[index].filterTypeId)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label={t('Reports.ReportFilters.AdaptiveSource')}
            value={reportFilter.adaptiveDataSource || ''}
            onChange={event => onPropertyChanged('adaptiveDataSource', event, index)}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label={t('Reports.ReportFilters.DisplayMember')}
            value={reportFilter.displayMember || ''}
            onChange={event => onPropertyChanged('displayMember', event, index)}
          />
        </Grid>
        <Grid item container xs={12} sm={4}>
          <Grid item xs={6}>
            <FormControlLabel
              label={t('Reports.ReportFilters.AllowNull')}
              control={
                <Checkbox
                  checked={reportFilter.allowNull}
                  color='primary'
                  onChange={event => onPropertyChanged('allowNull', event.target.checked, index)}
                />
              }
            />
          </Grid>
          {showMultipleSelectionBox && (
            <Grid item xs={6}>
              <FormControlLabel
                label={t('Reports.ReportFilters.AllowMultipleSelection')}
                control={
                  <Checkbox
                    checked={reportFilter.allowMultipleSelection}
                    color='primary'
                    onChange={event => {
                      onPropertyChanged('allowMultipleSelection', event.target.checked, index);
                      if (event.target.checked) onPropertyChanged('defaultValue', null, index);
                    }}
                  />
                }
              />
            </Grid>
          )}
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            label={t('Reports.ReportFilters.DefaultValue')}
            value={reportFilter.defaultValue || ''}
            onChange={event => onPropertyChanged('defaultValue', event, index)}
          />
        </Grid>
      </Grid>
    </>
  );
};

ReportFilterComponent.propTypes = {
  reportFilter: PropTypes.object,
  dictionaryEditorTypes: PropTypes.array,
  index: PropTypes.number,
  onPropertyChanged: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired
};

export default ReportFilterComponent;
